export default function viewmore() {
  (function ($) {
    $.fn.viewmore = function () {
      $('#view_more').append('<span>もっと見る</span><div class="m3pcom-btn-more--arr"><svg viewBox="0 0 512 493" style="enable-background:new 0 0 512 493;" xml:space="preserve"><path class="w-icon" d="M256,274L92,109C81.3,99,68.5,94,53.5,94s-27.7,5.2-38,15.5S0,132.5,0,147.5S5.3,175,16,185l240,241l240-241c10.7-10,16-22.5,16-37.5s-5.2-27.7-15.5-38c-10.3-10.3-23-15.5-38-15.5s-27.8,5-38.5,15L256,274z"></path></svg></div>');
    };
    document.addEventListener("DOMContentLoaded", $.fn.viewmore);
  })(jQuery);
}
